var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 139,
    viewBox: "0 0 239 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-598 -242)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(598 242)",
    fill: "#002849",
    fontSize: 96,
    fontFamily: "Jost-SemiBold, Jost",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.724,
    y: 103
  }, "4")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(762 242)",
    fill: "#002849",
    fontSize: 96,
    fontFamily: "Jost-SemiBold, Jost",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.724,
    y: 103
  }, "4")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682 247)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,88.838C5,74.37,13.384,49.8,41.8,33.643c0,0-12.942,22.1-1.045,18.168S47.985,30.653,67.136,20.7c0,0-7.464,16.182,3.22,13.025C84.51,29.566,83.465,8.262,109.955,5c0,0-31.277,25.988-25.57,33.431s25.57-18.8,25.57-18.8S108.2,44.828,86.476,50.327C54.049,58.523,59.066,84.991,82.315,64c0,0-18.858,45.954-56.2,45.954C11.335,109.955,5,99.836,5,88.838Z",
    transform: "translate(-3.955 -5)",
    fill: "#ffc96f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,288.953c0-15.513,14.907-24.712,26.26-29,0,0-8.781,10.914-1.505,10.5s10.516-14.28,22.329-12.231c0,0-14.51,10.809-11.185,21.43,2.467,7.861,10.182-5.687,10.182-5.687s-1.15,30.671-30.4,30.671",
    transform: "translate(-249.319 -205.114)",
    fill: "#db3529"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.763,
    cy: 15.763,
    rx: 15.763,
    ry: 15.763,
    transform: "translate(6.532 67.943)",
    fill: "#e36415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.275,340.1a15.7,15.7,0,0,0,21.284,21.284A15.687,15.687,0,1,1,348.275,340.1Z",
    transform: "translate(-333.619 -270.04)",
    fill: "#ef8039"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.937,
    cy: 1.883,
    rx: 4.937,
    ry: 1.883,
    transform: "translate(21.598 96.315) rotate(-161.348)",
    fill: "#e36415"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.473,
    cy: 2.09,
    rx: 4.473,
    ry: 2.09,
    transform: "matrix(-0.833, 0.553, -0.553, -0.833, 22.606, 73.758)",
    fill: "#b24e10"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.429,
    cy: 4.641,
    rx: 3.429,
    ry: 4.641,
    transform: "translate(26.95 79.26)",
    fill: "#b24e10"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 41.376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.662,267.524c18.482,0,34.476-7.067,44.637-13l-1.045-1.8c-9.952,5.791-25.57,12.712-43.592,12.712-12.189,0-20.071-7.882-20.071-20.071,0-13.548,6.251-41.71,6.314-42l-2.049-.46c-.251,1.171-6.356,28.685-6.356,42.442,0,6.544,2.07,12.084,6,16.057C202.473,265.413,208.055,267.524,214.662,267.524Z",
    transform: "translate(-192.5 -202.9)",
    fill: "#ffb234"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.165 85.845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.65,419.949c2.446-1.61,3.784-2.676,3.847-2.718l-1.3-1.631c-.021,0-1.338,1.045-3.7,2.613Z",
    transform: "translate(-152.5 -415.6)",
    fill: "#ffb234"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.d471af508593e869be14a742f9d1bf57.svg";
export { ForwardRef as ReactComponent };